import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const LengthCm = ({ lengthCm }: SpecProps<"length_cm">) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();

  if (lengthCm == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.length",
    message: "Length in cm",
    comment: "Field for 'length in cm' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: { length: formatNumber(lengthCm, locale) },
  });

  return <FieldValuePair field={field} value={value} />;
};
